<template>
  <div>
    <div class="search_form">
      <div class="modal-table__search">
        <label for="search-keyword" class="sr-only"
          >제조사명을 입력해주세요</label
        >
        <input
          type="text"
          id="search-keyword"
          placeholder="제조사명을 입력해주세요"
          v-model="makrSearchInfo"
          @keyup.enter="searchMakr"
        />
        <button type="button" class="btn btn--blue btn--m" @click="searchMakr">
          <i class="svg_icon icon_search white"></i>검색
        </button>
      </div>
    </div>

    <div class="board-wrapper">
      <div class="table-wrapper_w50" style="margin-right: 20px">
        <span class="modal-table-tit">제조사명 조회</span>
        <table class="modal-table type-m-none-thead">
          <caption>
            제조사명 조회
          </caption>
          <colgroup>
            <col width="100%" />
          </colgroup>
          <thead>
            <tr>
              <th v-for="field in fields1" :key="field.key">
                {{ field.label }}
              </th>
            </tr>
          </thead>
        </table>
        <div class="table-body-scroll">
          <table class="modal-table type-block--mobile">
            <caption class="sr-only">
              제조사명 조회 본문
            </caption>
            <colgroup>
              <col width="100%" />
            </colgroup>
            <tbody v-if="makrList.length > 0">
              <tr
                v-for="item in makrList"
                :key="item.cd"
                @click="onMakrRowClick(item)"
                class="line-height-10 clickable-row"
              >
                <td v-for="field in fields1" :key="field.key">
                  {{ item[field.key] }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="no-data">제조사를 검색해주세요</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="table-wrapper_w50">
        <span class="modal-table-tit">소프트웨어명 조회</span>
        <table class="modal-table type-block--mobile">
          <caption>
            소프트웨어명 조회
          </caption>
          <colgroup>
            <col width="100%" />
          </colgroup>
          <thead>
            <tr>
              <th v-for="field in fields2" :key="field.key">
                {{ field.label }}
              </th>
            </tr>
          </thead>
          <tbody v-if="swList.length > 0">
            <tr
              v-for="item in swList"
              :key="item.cd"
              @click="onSwRowClick(item)"
              class="line-height-10 clickable-row"
            >
              <td v-for="field in fields2" :key="field.key">
                {{ item[field.key] }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="no-data">검색된 소프트웨어 정보가 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref } from "vue";
import { useStore } from "vuex";
export default {
  setup(props, { emit }) {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const makrSearchInfo = ref("");
    const makrList = ref([]);
    const swList = ref([]);
    const selectedMakrNm = ref("");
    const selectedMakr = ref("");
    const fields1 = [{ key: "cdNm", label: "제조사명" }];
    const fields2 = [{ key: "cdNm", label: "소프트웨어명" }];

    // methods 정의
    // 제조사 검색
    const searchMakr = () => {
      const info = {
        field: "cdNm",
        keyword: makrSearchInfo.value,
        depth: 1,
      };
      showLoading();
      axios
        .post("/report/pr/code/makr/get", info)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            makrList.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    // 제조사 선택
    const onMakrRowClick = (item) => {
      searchSw(item.cd);
      selectedMakr.value = item.cd; // 선택된 제조사 저장
      selectedMakrNm.value = item.cdNm; // 선택된 제조사 이름 저장
    };
    // 소프트웨어 검색
    const searchSw = (makrCd) => {
      const info = {
        parntsCode: makrCd,
      };
      showLoading();
      axios
        .post("/report/pr/code/sw/get", info)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            swList.value = res.data.resList;
            if (swList.value.length === 0) {
              const emptyInfo = {
                cd: null,
                cdNm: "없음",
              };
              swList.value.push(emptyInfo);
            }
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    // 소프트웨어 선택
    const onSwRowClick = (item) => {
      const info = {
        makr: selectedMakr.value,
        makrName: selectedMakrNm.value,
        swNm: item.cd,
        swNmText: item.cdNm,
      };
      emit("add", info);
    };

    // html에서 사용될 데이터 정의
    return {
      makrSearchInfo,
      searchMakr,
      onSwRowClick,
      onMakrRowClick,
      makrList,
      swList,
      selectedMakr,
      selectedMakrNm,
      fields1,
      fields2,
    };
  },
};
</script>
